import { render, staticRenderFns } from "./MinigamesList.vue?vue&type=template&id=b61598a6&"
import script from "./MinigamesList.vue?vue&type=script&lang=js&"
export * from "./MinigamesList.vue?vue&type=script&lang=js&"
import style0 from "./MinigamesList.vue?vue&type=style&index=0&id=b61598a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports